import { SxProps, Theme, TooltipProps } from '@mui/material'
import { ExpenseStatus } from '@/types'
import { Indicator } from '@/components'

const getStatusColor = (status: ExpenseStatus | undefined): string => {
  switch (status) {
    case 'approved':
      return 'success.main'
    case 'pending':
      return 'warning.main'
    case 'declined':
      return 'error.main'
    default:
      return 'red'
  }
}

export type ExpenseStatusIndicatorProps = {
  status?: ExpenseStatus
  name: string
  isSmall?: boolean
  tooltipText?: string
  tooltipPlacement?: TooltipProps['placement']
  sxProps?: SxProps<Theme>
}

export const ExpenseStatusIndicator = ({
  isSmall = true,
  status,
  name,
  tooltipText,
  tooltipPlacement = 'top',
  sxProps = {},
}: ExpenseStatusIndicatorProps): JSX.Element => (
  <Indicator
    isSmall={isSmall}
    status={status}
    name={name}
    bgcolor={getStatusColor(status)}
    tooltipText={tooltipText}
    tooltipPlacement={tooltipPlacement}
    sxProps={sxProps}
  />
)
